import classes from './Filter.module.css';
import { useState, useEffect } from "react";
import { FilterOptions, Filter as FilterType } from "../../types/filters";
import React from "react";
import Button from '../ui/Button';

interface FilterProps {
  applyFilter: (param: FilterType) => void,
  resetFilters: () => void,
  page: string
};

const Filter = ({applyFilter, resetFilters, page}: FilterProps) => {

  // filter by event type, events I am booked to, in the next 7 days, in the next 1 month, all past events, all future events
  // by default, display all upcomming events
  // different pages should have more or less filters e.g., becasue the events page shows all events, it should only show events that havent happened yet

  // type will need a seperate filter becasue there are multiple types

  const [openCategories, setOpenCategories] = useState<Set<string>>(new Set());

  const applyFilterHandler = (filter: FilterType) => {
    applyFilter(filter);
  };

  const toggleFilterCategory = (label: string) => {
    setOpenCategories(prev => {
      const newSet = new Set(prev);
      if (newSet.has(label)) {
        newSet.delete(label)
      } else {
        newSet.add(label)
      }
      return newSet
    })
  };

  const resetFiltersHandler = () => {
    setOpenCategories(new Set());
    resetFilters();
  }

  const filterOptions = [
  { label: 'Type', type: 'Type', values: ['meeting', 'workshop', 'conference', 'party', 'training'] },
  { label: 'Date Time', type: 'Date', values: ['next7days', 'nextMonth']}];

  return (
    <div className={classes['filter-component']}>
      <div>
        <h3>Filters</h3>
        <ul className={classes['filter-container']}>
          {filterOptions.map(filter => {
            if (filter.type === 'Type' || filter.type === 'Booked' || filter.type === 'Date') {
              return (
              <li key={filter.label} className={classes['filter-category']}>
                <span className={classes['filter-category-label']} onClick={() => toggleFilterCategory(filter.label)}>{filter.label}</span>
                <div className={`${classes['filter-area']} ${openCategories.has(filter.label) ? classes.showing : ''}`}>
                  {openCategories.has(filter.label) && filter.values.map((value) => (
                    <label key={value} className={classes['filter-item']}>
                      <input type="checkbox" onChange={() => applyFilterHandler({"value": value, "type": filter.type})}/>
                      {value}
                    </label>
                  ))}
                </div>
              </li>)
            } 
          })}
          <Button text={'Reset'} onClick={resetFiltersHandler} />
        </ul>
      </div>
    </div>
  )
}

export default Filter;